/** @format */

import React, { Component } from 'react';
import I18n from '../../components/Translate/I18n';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from './../Card/CardHeader';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';

class CardHeaderExtRight extends Component {
    render() {
        const { classes, icon, trans, color, additionalContent } = this.props;
        const colors = this.props.color ? color : 'info';
        return (
            <CardHeader color={color} icon>
                <GridContainer>
                    <GridItem xs={6}>
                        <CardIcon color={colors}>{icon}</CardIcon>
                        <h4 className={classes.cardIconTitle}>{trans && <I18n trans={trans} />}</h4>
                    </GridItem>
                    <GridItem xs={6} style={{ textAlign: 'right' }}>
                        {additionalContent && <React.Fragment>{additionalContent}</React.Fragment>}
                    </GridItem>
                </GridContainer>
            </CardHeader>
        );
    }
}

CardHeaderExtRight.propsTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.string,
    trans: PropTypes.string,
    icon: PropTypes.object,
    additionalContent: PropTypes.object,
};

export default withStyles(adescomStyle)(CardHeaderExtRight);
